import "./App.scss";
import { Button, Container, Stack } from "@mui/material";
import Main from "./ui/layout/main";
import Layout from "./ui/layout/layout";


function App() {
  return (
    <>
      <Layout></Layout>
    </>
  );
}

export default App;
